import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 8;

const ProducingAreaMain = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex}></TabRouting>;
};
export default ProducingAreaMain;
